import { get } from "../methods";
function getMarketMovers(market = "us", industryId, headers = {}) {
  return get({
    url: `/api/market/market-movers/${market}${industryId ? `/${industryId}` : ""}`,
    headers
  });
}
export {
  getMarketMovers as default
};
